import React from "react";
import "./NewsAbout.scss";
import { useStoreState } from "easy-peasy";
import * as conf from "../../../config";
import noPhoto from "../../images/newsIcon.svg";
import ArrowBack from "../../images/arrowBack.svg";
import { useHistory } from "react-router-dom";

const NewsAbout = () => {
  const chosenNew = useStoreState((state) => state.api.chosenNew);
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="mainNewsAbout">
      <div className="navLine"></div>
      <div className="container">
        <img
          src={ArrowBack}
          alt="ArrowBack"
          className="arrowBack"
          onClick={() => goBack()}
        />
        <h2>{chosenNew.title}</h2>
        <div className="picContainer">
          <img
            className="pic"
            src={
              chosenNew.media[0]
                ? conf.API_HOST + chosenNew.media[0].url
                : noPhoto
            }
            style={
              chosenNew.media[0]
                ? { width: "100%", height: "100%" }
                : { width: "85%", height: "85%" }
            }
            alt="pic"
          />
          <div className="background"></div>
        </div>
        <div
          className="text ql-editor"
          dangerouslySetInnerHTML={{ __html: chosenNew.post }}
        ></div>
      </div>
    </div>
  );
};

NewsAbout.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.api.getApiSlug(props.match.params.id);
    if (!props.store.getState().api.chosenNew.id) {
      return { redirectTo: "/404" };
    }
  } else {
    const store = require("../../client");
    await store.default.dispatch.api.getApiSlug(props.match.params.id);
    if (!store.default.getState().api.chosenNew.id) {
      return { redirectTo: "/404" };
    }
  }
  return { whatever: "stuff" };
};

export default NewsAbout;
